import { collectBookingErrors, bookingErrorMessage } from './booking-errors'

describe('collectBookingErrors', () => {
  it('extracts spraypaint validation messages', () => {
    const op = {
      errors: {
        option: { message: "Option can't be blank" },
        base: { title: 'Cart must not be purchased' },
      },
    }

    expect(collectBookingErrors(op, null)).toEqual([
      "Option can't be blank",
      'Cart must not be purchased',
    ])
  })

  it('includes a thrown error message and de-dupes repeats', () => {
    const op = { errors: { base: { message: 'Network error' } } }

    expect(collectBookingErrors(op, new Error('Network error'))).toEqual(['Network error'])
  })

  it('handles a model with no usable errors', () => {
    expect(collectBookingErrors({}, null)).toEqual([])
    expect(collectBookingErrors(null, null)).toEqual([])
    expect(collectBookingErrors({ errors: {} }, null)).toEqual([])
  })
})

describe('bookingErrorMessage', () => {
  it('uses the real server reason when present', () => {
    expect(bookingErrorMessage('reserve your time', ['9:00 AM was just taken.']))
      .toBe("We couldn't reserve your time: 9:00 AM was just taken.")
  })

  it('falls back to a contact prompt (never "refresh") when no reason is known', () => {
    const msg = bookingErrorMessage('add your sitting to the cart', [])
    expect(msg).toContain("We couldn't add your sitting to the cart")
    expect(msg).toContain('Please try again')
    expect(msg).not.toContain('refresh')
  })
})
